import { withTranslation } from 'react-i18next';
import GettingStarted from './GettingStarted.layout';

export default withTranslation('getting-started')(GettingStarted);
